export const common = {
  // Navbar
  'nav.home': 'Home',
  'nav.overview': 'Overview',
  'nav.directory': 'Church Directory',
  'nav.worship': 'Worship Operations',
  'nav.live': 'Live Sabbath',
  'nav.ministries': 'Ministries',
  'nav.events': 'Events',
  'nav.tools': 'Tools',
  'nav.resources': 'Resources Hub',
  'nav.adminLogin': 'Admin Login',
  'nav.language': 'Language',
  
  // Language names
  'lang.english': 'English',
  'lang.yoruba': 'Yoruba',
  'lang.hausa': 'Hausa',
  'lang.igbo': 'Igbo',
  'lang.pidgin': 'Pidgin',
  
  // Hero Section
  'hero.badge': 'National Digital Worship Infrastructure',
  'hero.title': 'Empowering Every Seventh-day Adventist Church in Nigeria',
  'hero.description': 'A unified digital platform connecting all SDA churches across Nigeria. Access live worship services, find churches near you, manage events, and strengthen our community through technology.',
  'hero.exploreChurches': 'Explore Churches',
  'hero.worshipTools': 'Worship Tools',
  'hero.liveNow': 'Live Now',
  'hero.scrollExplore': 'Scroll to explore',
  
  // Stats
  'stats.churches': 'Churches',
  'stats.members': 'Active Members',
  'stats.liveServices': 'Live Services Weekly',
  'stats.events': 'Monthly Events',
  
  // Features
  'features.watchLive': 'Watch Live',
  'features.watchLiveDesc': 'Join live worship services from churches across Nigeria',
  'features.findChurch': 'Find Church',
  'features.findChurchDesc': 'Locate SDA churches in your area with detailed information',
  'features.events': 'Events',
  'features.eventsDesc': 'Stay updated with conferences, programs, and activities',
  'features.ministriesTitle': 'Ministries',
  'features.ministriesDesc': 'Connect with various ministry departments and programs',
  
  // CTA
  'cta.title': 'Ready to Connect Your Church?',
  'cta.description': 'Join the national network and bring your congregation into the digital age. Access powerful tools for worship, communication, and community building.',
  'cta.getStarted': 'Get Started Today',
  'cta.learnMore': 'Learn More',
  
  // Footer
  'footer.tagline': 'Connecting Seventh-day Adventist churches across Nigeria through innovative digital solutions.',
  'footer.quickLinks': 'Quick Links',
  'footer.resources': 'Resources',
  'footer.contact': 'Contact',
  'footer.home': 'Home',
  'footer.about': 'About Us',
  'footer.churches': 'Churches',
  'footer.liveStream': 'Live Stream',
  'footer.worshipGuide': 'Worship Guide',
  'footer.techSupport': 'Tech Support',
  'footer.training': 'Training',
  'footer.documentation': 'Documentation',
  'footer.email': 'Email',
  'footer.phone': 'Phone',
  'footer.address': 'Address',
  'footer.rights': 'All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  
  // Directory Page
  'directory.title': 'Church Directory',
  'directory.subtitle': 'Find Seventh-day Adventist churches across Nigeria',
  'directory.search': 'Search churches...',
  'directory.allRegions': 'All Regions',
  'directory.allStates': 'All States',
  'directory.viewDetails': 'View Details',
  'directory.getDirections': 'Get Directions',
  'directory.members': 'members',
  
  // Live Page
  'live.title': 'Live Worship Services',
  'live.subtitle': 'Join live Sabbath services from churches across Nigeria',
  'live.allRegions': 'All Regions',
  'live.watchNow': 'Watch Now',
  'live.viewers': 'viewers',
  'live.starting': 'Starting',
  
  // Events Page
  'events.title': 'Upcoming Events',
  'events.subtitle': 'Discover conferences, workshops, and programs across Nigeria',
  'events.allCategories': 'All Categories',
  'events.register': 'Register Now',
  'events.learnMore': 'Learn More',
  'events.attendees': 'attendees',
  
  // Ministries Page
  'ministries.title': 'Ministry Departments',
  'ministries.subtitle': 'Explore our various ministry programs and departments',
  'ministries.learnMore': 'Learn More',
  'ministries.programs': 'programs',
  
  // Tools Page
  'tools.title': 'Worship Tools',
  'tools.subtitle': 'Digital solutions for modern church management',
  'tools.getStarted': 'Get Started',
  'tools.learnMore': 'Learn More',
};

export default {
  ...common,
  
  // New translations for enhanced landing page
  whatYouCanDo: 'What You Can Do',
  platformDescription: 'Discover all the ways our platform helps you stay connected with your church community and grow in faith',
  learnMore: 'Learn More',
  
  // Feature cards
  watchLive: 'Watch Live',
  watchLiveDesc: 'Join live worship services from churches across Nigeria',
  findChurch: 'Find Church',
  findChurchDesc: 'Locate SDA churches in your area with detailed information',
  events: 'Events',
  eventsDesc: 'Stay updated with conferences, programs, and activities',
  ministries: 'Ministries',
  ministriesDesc: 'Connect with various ministry departments and programs',
  
  howItWorks: 'How It Works',
  howItWorksDesc: 'Getting started is simple. Follow these four easy steps to begin your journey',
  
  discoverChurches: 'Discover Churches',
  discoverChurchesDesc: 'Browse our comprehensive directory of Seventh-day Adventist churches across Nigeria. Find locations, service times, and contact information',
  
  joinWorship: 'Join Live Worship',
  joinWorshipDesc: 'Watch live-streamed services from churches nationwide. Experience worship from anywhere, anytime',
  
  participateEvents: 'Participate in Events',
  participateEventsDesc: 'Stay informed about conferences, workshops, and community programs. Register and participate in upcoming events',
  
  connectCommunity: 'Connect with Community',
  connectCommunityDesc: 'Engage with ministries, join small groups, and build meaningful relationships with fellow believers',
  
  whyChooseUs: 'Why Choose Our Platform',
  whyChooseUsDesc: 'Built specifically for the Seventh-day Adventist community in Nigeria with features that matter most',
  
  accessAnywhere: 'Access Anywhere',
  accessAnywhereDesc: 'Connect with your church community from any device, whether you\'re at home or on the go',
  
  secureReliable: 'Secure & Reliable',
  secureReliableDesc: 'Your data is protected with enterprise-grade security. Enjoy uninterrupted service you can trust',
  
  mobileOptimized: 'Mobile Optimized',
  mobileOptimizedDesc: 'Fully responsive design ensures a seamless experience on smartphones, tablets, and desktops',
  
  communityFocused: 'Community Focused',
  communityFocusedDesc: 'Built with input from church leaders and members to serve the unique needs of our community',
  
  stayUpdated: 'Stay Updated',
  stayUpdatedDesc: 'Receive notifications about important events, new sermons, and community announcements',
  
  comprehensiveTools: 'Comprehensive Tools',
  comprehensiveToolsDesc: 'Access a complete suite of digital tools designed to enhance church management and member engagement'
};
